import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { StickyBar } from './components/StickyBar';
import { ExitIntentPopup } from './components/ExitIntentPopup';
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const MechanismSection = lazy(() => import('./components/MechanismSection').then(m => ({
  default: m.MechanismSection
})));
const OfferSection = lazy(() => import('./components/OfferSection').then(m => ({
  default: m.OfferSection
})));
const ObjectionsSection = lazy(() => import('./components/ObjectionsSection').then(m => ({
  default: m.ObjectionsSection
})));
const CTASection = lazy(() => import('./components/CTASection').then(m => ({
  default: m.CTASection
})));
const ClosingSection = lazy(() => import('./components/ClosingSection').then(m => ({
  default: m.ClosingSection
})));
export function App() {
  useEffect(() => {
    document.title = 'Audiobook Hábitos Atómicos Espirituales';
    // Meta Pixel
    if (!(window as any).fbq) {
      const n = ((window as any).fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      }) as any;
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
    ;
    (window as any).fbq('init', '1588595258841964');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <div className="w-full min-h-screen bg-[#0f0529]" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1588595258841964&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <HeroSection data-id="element-3" />
      <Suspense fallback={<div className="h-32" data-id="element-5" />} data-id="element-4">
        <PainSection data-id="element-6" />
        <MechanismSection data-id="element-7" />
        <OfferSection data-id="element-8" />
        <ObjectionsSection data-id="element-9" />
        <CTASection data-id="element-10" />
        <ClosingSection data-id="element-11" />
      </Suspense>
      <StickyBar data-id="element-12" />
      <ExitIntentPopup data-id="element-13" />
    </div>;
}